import React, { MouseEvent, useContext, useRef } from 'react';
import { RocheTeaser as RocheTeaserType } from '../../types/global';
import { parseAssetSource, parseDownloadSource } from '../../utils/asset';
import { StringService } from '../../services/string';
import { BlokToComponentProps } from '../../helpers/blok-to-component/types';
import { AssetData } from '../../utils/asset/types';
import { RocheUITeaser } from '@repo/roche-ui';
import { handleRocheTeaserClick } from '../../helpers/roche-teaser-tracking';
import { TeaserImage } from './types';
import { getAltText } from './alt-text-helper';
import { DateFormattingService } from '../../services/date-time-formatter';
import { RocheXXTranslationContext } from '../../contexts/translation';
import { useTranslation } from '../../hooks/use-translation';

type RocheDownloadTeaserProps = BlokToComponentProps<
  RocheTeaserType & {
    teaser_overline: string;
    teaser_title: string;
    teaser_image: TeaserImage[];
    internal_asset: AssetData;
    external_asset: string;
    publishing_date: string;
  }
>;

export const RocheDownloadTeaser = ({ blok, slot }: RocheDownloadTeaserProps): JSX.Element => {
  const teaserRef = useRef<HTMLDivElement>(null);

  const teaserImage = blok?.teaser_image?.[0];
  const teaserImageAlt = getAltText(blok?.teaser_image[0]);
  const internalAsset = blok?.internal_asset?.filename;
  const externalAsset = blok?.external_asset;
  const publishingDate = blok?.publishing_date;
  const externalAssetLink = `${process.env.GATSBY_CORS_HEADER_API}?url=${externalAsset}`;
  const teaserUrl = parseDownloadSource(internalAsset) || externalAssetLink;
  const translations = useContext(RocheXXTranslationContext);
  const formattedDate =
    publishingDate && typeof document !== 'undefined'
      ? DateFormattingService.formatDate(publishingDate, 'dateFull', translations)
      : '';
  const downloadTranslation = useTranslation('download');

  return (
    <>
      {blok && (
        <RocheUITeaser
          ref={teaserRef}
          layout={blok.layout}
          teaserTitle={blok.teaser_title}
          teaserOverline={blok.teaser_overline || formattedDate}
          teaserDescription={StringService.getExtension(internalAsset || externalAsset).toUpperCase()}
          teaserImage={parseAssetSource(teaserImage?.src.filename)}
          teaserImageAlt={teaserImageAlt}
          teaserUrl={teaserUrl}
          isDownloadLink
          downloadTranslation={downloadTranslation}
          loaded={true}
          slot={slot}
          onTeaserClick={(e: MouseEvent) => handleRocheTeaserClick(e, blok.teaser_title, teaserUrl, teaserRef, true)}
        />
      )}
    </>
  );
};
